import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/workflow-roles/{roleId}']['DELETE'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const deleteCreatorWorkflowRole = async ({ creatorId, roleId }: Input): Promise<Output> => {
  const data = await noodleApiClient.delete(`/creators/${creatorId}/workflow-roles/${roleId}`);
  return data.data;
};

export default deleteCreatorWorkflowRole;
